import React, { useState } from "react";
import "./Landing.css";
import { Link } from "react-router-dom";
// import homeBanner1 from "../../image/home_banner/admissionbannernew1.jpg";
// import homeBanner2 from "../../image/home_banner/admissionbannernew2.jpg";
import homeBanner3 from "../../image/home_banner/banner1.webp";
import homeBanner4 from "../../image/home_banner/Home_banner.webp";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination, Navigation, Autoplay } from "swiper";

function Landing({ video, cover }) {
  const [isMuted, setIsMuted] = useState(true);

  return video ? (
    <div className="position-relative top8margin">
      {/* <ReactPlayer
        url={campus}
        loop={true}
        muted={isMuted}
        playing={true}
        controls={false}
        width="100%"
        className="landing_video"
      />*/}
      <div id="carouselExampleIndicators" className="carousel slide ">
        <div>
          <div className="carousel-indicators d-none">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <Link to="/admissions" className="landing-admissions-banner">
                <img
                  src={homeBanner4}
                  alt="Student showcasing a robotics project in a STEAM classroom"
                  className="landing-admissions-banner-image"
                />
                <div className="landing-admissions-banner-content">
                  <h1 className="landing-admissions-banner-headline">
                    <span>Big Ideas Begin Here.</span>
                    <span className="landing-admissions-banner-highlight">
                      Future Leaders Start Here.
                    </span>
                  </h1>
                  <p className="landing-admissions-banner-description">
                    Discover a world of learning where academic excellence meets
                    creativity, innovation, hands-on STEAM experiences, and
                    holistic development.
                  </p>
                  <p className="landing-admissions-banner-grades">
                    Nursery - Grade 9
                  </p>
                  <span className="landing-admissions-banner-cta">
                    APPLY FOR ADMISSION
                  </span>
                </div>
              </Link>
            </div>
            {/* <div className="carousel-item">
            <Link to="/admissions">
              <img
                src={homeBanner2}
                width="100%"
              />
              </Link>
            </div>
            <div className="carousel-item">
            <Link to="/admissions">
              <img
                src={homeBanner3}
                width="100%"
              />
              </Link>
            </div> */}
          </div>
          <button
            className="carousel-control-prev d-none"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next d-none"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>         
        </div>
      </div>
    </div>
  ) : (
    <div className="cover_img_cont">
      <img src={cover} alt="images" className="cover_img" />
    </div>
  );
}

export default Landing;
